import { render, staticRenderFns } from "./layout-normal.vue?vue&type=template&id=963be294&scoped=true&"
import script from "./layout-normal.vue?vue&type=script&lang=js&"
export * from "./layout-normal.vue?vue&type=script&lang=js&"
import style0 from "./layout-normal.vue?vue&type=style&index=0&id=963be294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963be294",
  null
  
)

export default component.exports